import React from "react";
import "./AboutMe.css";
export default function AboutMe() {
  return (
    <div id="AboutMe" className="aboutMe-container">
      <div className="header-container">
        {" "}
        <h2>
          <span className="primary-text">About Me</span>
        </h2>{" "}
        <span style={{ color: "grey" }}>Why Choose Me ?</span>
        <span> &#8594; &#9827; &#8592;</span>
      </div>
      <div className="aboutMe-box">
        <div className="aboutMe-picture"></div>
        <div className="aboutMe-text">
          <span>
            I am a B-Tech graduate from TINT, Newtown. I am able to write clean
            and efficient code. I am good at problem-solving, Object-Oriented
            Programming, System Design, and Back-end Development. I am a MERN
            stack Developer and I consider myself a good team worker and quick
            learner with a positive and hardworking attitude.
          </span>
          <div className="highlight-features">
            <h5>Here are a Few Hihglights:</h5>
            <ul className="custom-bullet-list">
              <li>
                <i
                  class="fa-solid fa-circle-dot fa-rotate-90 fa-sm"
                  style={{ color: "#e07800" }}
                ></i>
                &nbsp;&nbsp;MERN Stack Developer
              </li>
              <li>
                {" "}
                <i
                  class="fa-solid fa-circle-dot fa-rotate-90 fa-sm"
                  style={{ color: "#e07800" }}
                ></i>
                &nbsp;&nbsp;420+ Question Solved on LeetCode
              </li>
              <li>
                {" "}
                <i
                  class="fa-solid fa-circle-dot fa-rotate-90 fa-sm"
                  style={{ color: "#e07800" }}
                ></i>
                &nbsp;&nbsp;IEEE-Xplore Author
              </li>
              <li>
                {" "}
                <i
                  class="fa-solid fa-circle-dot fa-rotate-90 fa-sm"
                  style={{ color: "#e07800" }}
                ></i>
                &nbsp;&nbsp;Building REST API
              </li>
              <li>
                {" "}
                <i
                  class="fa-solid fa-circle-dot fa-rotate-90 fa-sm"
                  style={{ color: "#e07800" }}
                ></i>
                &nbsp;&nbsp;ACM Hack-a-Day Finalist
              </li>
              <li>
                {" "}
                <i
                  class="fa-solid fa-circle-dot fa-rotate-90 fa-sm"
                  style={{ color: "#e07800" }}
                ></i>
                &nbsp;&nbsp;Managing Database
              </li>
            </ul>
            <div className="profile-options">
              <a href="#ContactMe">
                <button className="btn primary-btn">
                  {""}
                  Hire Me{" "}
                </button>
              </a>
              <a href="RESUME.pdf" download="Kokonod Ray RESUME.pdf">
                <button
                  style={{
                    borderColor: "#1f2235",
                    backgroundColor: "var(--dark-orange)",
                    color: "white",
                  }}
                  className="btn highlighted-btn"
                >
                  Get Resume
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
